import React, { memo, useState } from "react";
import styled from "styled-components";
import { Tooltip, tooltipClasses } from "@mui/material";
import VisibilityIcon from "@material-ui/icons/Visibility";
import { moduleSettings } from "../../stores/module-settings.store";

interface ITooltip {
  title: string;
  text: string;
}

interface IStyled {
  fontFamily?: string;
}

const TooltipLayout = styled.div<IStyled>`
  font-family: ${(props) => props.fontFamily};
`;

const TooltipPreview = styled.div`
  line-height: 1;
  cursor: pointer;
`;

const TooltipTitle = styled.div`
  font-size: 14px;
  line-height: 27px;
  font-weight: bold;
`;

const TooltipText = styled.div`
  font-size: 12px;
  line-height: 17px;
  white-space: pre-line;
  max-height: 300px;
  overflow-y: auto;
`;

const ShowMoreIcon = styled(VisibilityIcon)`
  color: ${(props) => props.theme.disabledColor};
`;

const CustomTooltip = styled(({ className, ...props }) => (
  <Tooltip disableTouchListener {...props} classes={{ popper: className }} />
))(() => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: `white`,
    color: "#333",
    boxShadow: `0px 2px 4px 0px rgba(0,0,0,0.25)`,
    marginTop: `7px !important`,
  },
}));

const TooltipWrapper = (props: ITooltip) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const mappedText = props.text.split("\r\n").join("</br>");
  const fontFamily = moduleSettings.fontFamily;

  const tooltipContent = (
    <TooltipLayout fontFamily={fontFamily}>
      <TooltipTitle>{props.title}</TooltipTitle>
      <TooltipText>
        <span dangerouslySetInnerHTML={{ __html: mappedText }}></span>
      </TooltipText>
    </TooltipLayout>
  );

  return (
    <CustomTooltip
      data-test="golTooltip"
      title={tooltipContent}
      open={showTooltip}
      onOpen={() => setShowTooltip(true)}
      onClose={() => setShowTooltip(false)}
    >
      <TooltipPreview>
        <ShowMoreIcon onClick={() => setShowTooltip(!showTooltip)} />
      </TooltipPreview>
    </CustomTooltip>
  );
};

export const GolTooltip = memo(TooltipWrapper);
